import React from "react";

export default function TriangleDodAsyncPlanner({ children }) {
  return <>{children}</>;
}

